import { SUPPORTED_LOCALES } from "@/constants/locale";

export function getLocaleConfig(locale = "en") {
  return SUPPORTED_LOCALES.find((loc) => loc.code === locale);
}
